import React, { FC } from 'react';
import { View } from 'react-native';
import styles from './styles';

export type ButtonGroupProps = {
  children: any;
  direction: 'column' | 'row';
  style?: any;
};

export const ButtonGroup: FC<ButtonGroupProps> = ({
  children,
  direction,
  style,
}) => {
  const isRow = direction === 'row';
  const isColumn = direction === 'column';
  const getGroupDirection = () => {
    if (isRow) {
      return styles.containerRow;
    }
    if (isColumn) {
      return styles.containerColumn;
    }
  };
  const buttonGroupStyle = getGroupDirection();
  return <View style={[buttonGroupStyle, style]}>{children}</View>;
};

export default ButtonGroup;
